import Icon from 'veui/components/Icon'
import { IconCaretRight } from 'dls-icons-vue'

Icon.register('caret-right', IconCaretRight)
